<template>
    <div>
        <div class="study-container">
            <div class="main-study">
                <ul>
                    <li v-for="item in videoList" class="learn-ls" @click="playVideoItem(item)">
                        <div class="list-video-bg">
                            <img v-if="item.thumbnailId" width="100%" height="100%" :src="'resrun-paas/file/downloadFileStream/'+item.thumbnailId" :alt="item.learnName" >
                        </div>
                        <p class="learn-name">{{ item.learnName }}</p>
                        <p class="learn-desc" :title="item.learnDesc">{{ item.learnDesc }}</p>
                    </li>
                </ul>
            </div>
        </div>
        <PlayVideoModal ref="playVideo"/>
    </div>
    
</template>

<script>
import PlayVideoModal  from './modal/PlayVideoModal.vue';

import { getCopyrightStudy } from '@/api/business'
    export default {
        name:'Study',
        components:{
            PlayVideoModal
        },
        data () {
            return {
                isPlay:true,
                videoList:[],
                videoInfo:{
                    learnAddress:'',
                    thumbnailId:'',
                    learnName:'',
                    learnDesc:'',
                }
            }
        },
        mounted() {
            getCopyrightStudy().then(res=>{
                if(res.code==200){
                    this.videoList = res.result.records;
                    this.videoInfo = this.videoList.length?this.videoList[0]:this.videoInfo;
                }
            })
        },
        methods: {

            handlePlay(){
                let videoDom = this.$refs.video;
                if(videoDom){
                    videoDom.play();
                    this.isPlay = false;
                }
               
            },
            handleFullScreen(){
                let videoDom = this.$refs.video;
                if(videoDom && videoDom.requestFullscreen){
                    videoDom.requestFullscreen()
                    return
                }
                if(videoDom && videoDom.mozRequestFullscreen){
                    videoDom.mozRequestFullscreen()
                    return
                }
                if(videoDom && videoDom.webkitRequestFullscreen){
                    videoDom.webkitRequestFullscreen()
                    return
                }
            },
            handleVideoClick(val){
                // this.videoInfo = this.videoList?this.videoList[val]:this.videoInfo;
            },
            playVideoItem(item){
                this.$refs.playVideo.showDialog(item,this.videoList);
            },
        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style lang="less" scoped>
.study-container{
    margin-top: 68px;
    background-color: #fff;
    // min-height: 100vh;
    text-align: left;
    .main-study{
        box-sizing: border-box;
        width: 1200px;
        margin: 0 auto;
        padding: 80px 0;
        ul{
            display: flex;
            flex-wrap: wrap;
        }
        ul li{
            width: 364px;
            // height: 322px;
            cursor: pointer;
            .list-video-bg{
                width: 364px;
                height: 200px;
                overflow: hidden;
                img{
                    transition: .5s;
                }
                // img:hover{
                //     transform: scale(1.1);
                // }
            }
            .learn-name{
                font-family: Source Han Sans CN;
                font-size: 16px;
                font-weight: 600;
                line-height: 50px;
                color: #666;
                padding: 10px;
            }
            .learn-desc{
                font-family: Source Han Sans CN;
                font-size: 14px;
                font-weight: 700;
                line-height: 21px;
                color: #999;
                max-width: 337px;
                // display: -webkit-box;
                // -webkit-box-orient: vertical;
                // -webkit-line-clamp: 2;
                // overflow: hidden;
                // text-overflow: ellipsis;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                line-height: 1.5;
                -webkit-line-clamp: 2; //（行数）
                -webkit-box-orient: vertical;
                margin-top: 5px;
            }
        }
        ul li:hover{
            .list-video-bg{
                img{
                    transform: scale(1.1);
                }
            }
            .learn-name{
                background-color: #206BD1;
                color: #fff;
            }
        }
        ul li:nth-child(3n + 2 ),ul li:nth-child(3n + 3 ){
            margin-left: 20px;
        }
        ul li:nth-child(n + 4){
            margin-top: 20px;
        }
        
    }
}
</style>